import $http from '@/resource';
import utils from '@/utils';
import {Message, Notice} from 'view-design';

const $api = {};


/**
 * 获取附件列表
 *
 * @returns {Promise<any>}
 */
$api.cameraAttachment = function() {
	const url = 'camera-attachment';
	const promise = new Promise(function(resolve){
		$http.get(url).then(function (response) {
		  	if (response.code == 200) {
		  	  	resolve(response.data);
		  	}else{
		  		utils.notice(response.msg, 'error');
		  	}
		});
	});
  	return promise;
}

/**
 * 批量删除附件
 *
 * @param {array} picIds 待删除的id
 *
 * @returns {Promise<any>}
 */
$api.deleteCameraAttachment = function(picIds) {
	const url = 'camera-attachment';
	const promise = new Promise(function(resolve){
		$http.put(url, picIds).then(function (response) {
		  	if (response.code == 200) {
		  		utils.notice(response.msg, 'success');
		  		resolve();
		  	}else{
		  		utils.notice(response.msg, 'error');
		  	}
		});
	});
  	return promise;
}


export default $api; 


// WEBPACK FOOTER //
// ./src/service/usercenter/images.js